import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { getRunTopicComponentId } from '../../../../utilities/helpers';

const RunFlowTopicsObserver = ({ flow, onRunFlowTopicIdsChange, shouldShowRunTopicCard }) => {
  useEffect(() => {
    if (typeof onRunFlowTopicIdsChange !== 'function') return;
    if (!Array.isArray(flow?.topics)) return;
    const shouldIncludeTopic =
      typeof shouldShowRunTopicCard === 'function'
        ? shouldShowRunTopicCard
        : (topic) => !topic?.isHidden;
    const visibleTopicIds = flow.topics
      .filter((topic) => shouldIncludeTopic(topic))
      .map((topic) => getRunTopicComponentId(topic))
      .filter((topicId) => topicId != null);

    onRunFlowTopicIdsChange(visibleTopicIds);
  }, [flow?.topics, onRunFlowTopicIdsChange, shouldShowRunTopicCard]);

  return null;
};

RunFlowTopicsObserver.propTypes = {
  flow: PropTypes.shape({
    topics: PropTypes.arrayOf(
      PropTypes.shape({
        component_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        componentId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        isHidden: PropTypes.bool,
        status: PropTypes.string,
        tags: PropTypes.object,
        topic_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        topicId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      })
    ),
  }),
  onRunFlowTopicIdsChange: PropTypes.func,
  shouldShowRunTopicCard: PropTypes.func,
};

export default RunFlowTopicsObserver;
